import script from "./ProcedureReturnToPublished.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProcedureReturnToPublished.vue?vue&type=script&setup=true&lang=ts"

import "./ProcedureReturnToPublished.vue?vue&type=style&index=0&id=0daefc31&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0daefc31"]])

export default __exports__